import axios from "./axios";
import {
  optionTypeForApi,
  strikePriceForApi,
} from "../pages/OrderInitiatePage/utils";

export function buildQuoteDataRequestListAllRows(scriptSelections) {
  return (scriptSelections || []).map((s) => ({
    exchange: (s.exchange ?? "").toString().trim(),
    segment: (s.segment ?? "").toString().trim(),
    symbol: (s.symbol ?? "").toString().trim(),
    option_type: optionTypeForApi(s),
    strike_price: strikePriceForApi(s),
    expiry_date: (s.expiry_date ?? "").toString().trim(),
  }));
}

export const getOrderInitiationConfig = async (requestQuoteDataList, options = {}) => {
  const { signal } = options;
  const list = Array.isArray(requestQuoteDataList) && requestQuoteDataList.length > 0
    ? requestQuoteDataList
    : [{ exchange: "", segment: "", symbol: "", option_type: "", strike_price: "", expiry_date: "" }];
  const response = await axios.get("/api/broker-gateway/get-quote-data/", {
    params: {
      request_quote_data_list: JSON.stringify(list),
      type: "get_quote_drop_down_options"
    },
    signal
  });
  return response.data;
};

export const getQuoteData = async (requestQuoteDataList, options = {}) => {
  const { signal } = options;
  if (!Array.isArray(requestQuoteDataList) || requestQuoteDataList.length === 0) {
    return { quote_data_list: [] };
  }
  const response = await axios.get("/api/broker-gateway/get-quote-data/", {
    params: {
      request_quote_data_list: JSON.stringify(requestQuoteDataList),
      type: "get_quote_data"
    },
    signal
  });
  return response.data;
};

/**
 * Baskets with per-client multipliers for Order Initiate.
 * GET /api/broker-gateway/baskets-multiplier/
 * @returns {Promise<{ response: Array<{ id: string, basket_name: string, clients: Array<{ broker_client_code: string, multiplier: number }> }> }>}
 */
export const getBaskets = async (options = {}) => {
  const { signal } = options;
  const response = await axios.get(`/api/broker-gateway/baskets-multiplier/`, { signal });
  return response.data;
};

export const getClientsWithMargin = async (options = {}) => {
  const { signal } = options;
  const response = await axios.get(`/api/broker-gateway/get-clients-with-margin/`, { signal });
  return response.data;
};

export const getOrderInitiationScripInfo = async (requestScripList, underlyingToken, options = {}) => {
  const { signal } = options;
  const response = await axios.post(
    "/api/broker-gateway/get-order-initiation-scrip-info/",
    {
      request_scrip_list: requestScripList,
      request_underlying_instrument_token: underlyingToken,
    },
    { signal }
  );
  return response.data;
};

export const orderInitiate = async (scripList, clientMultipliers, options = {}) => {
  const { signal } = options;
  const payload = { scrip_list: scripList, client_multipliers: clientMultipliers };
  const response = await axios.post("/api/broker-gateway/order-initiate/", payload, { signal });
  return response.data;
};

export const getStrategies = async (options = {}) => {
  const { signal } = options;
  const response = await axios.get("/api/strategy/strategies/", { signal });
  return response.data;
};
